import React, { memo } from "react";
import submit from "submit-form";
import FilterChips from "../../../athlete-portal/calendar/FilterChips";

const SelectedExercises = ({
  selectedExercises,
  handleDeselect,
  deselectAll,
  isOnboarding = false,
  classNames = "",
}) => {
  const {
    squat,
    bench,
    deadlift,
    assistant,
    clean,
    jerk,
    snatch,
    overheadPress,
    other,
  } = selectedExercises;

  const handleSave = (e) => {
    e.preventDefault();
    submit("/actions/user/catalog-add-exercises", {
      method: "POST",
      body: { selectedExercises },
    });
  };

  const invalid =
    !squat.length &&
    !bench.length &&
    !deadlift.length &&
    !assistant.length &&
    !clean.length &&
    !jerk.length &&
    !snatch.length &&
    !overheadPress.length &&
    !other.length;

  return (
    <section className={classNames}>
      <header>
        <h3>{isOnboarding ? "Your Exercises" : "Selected exercises"}</h3>
        <button
          data-button-type="secondary"
          onClick={deselectAll}
          disabled={invalid ? true : undefined}
        >
          Clear All
        </button>
      </header>

      <div>
        <fieldset>
          <legend>Accessories</legend>
          <FilterChips
            filters={assistant.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(assistant.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Squat</legend>
          <FilterChips
            filters={squat.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(squat.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Bench Press</legend>
          <FilterChips
            filters={bench.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(bench.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Deadlift</legend>
          <FilterChips
            filters={deadlift.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(deadlift.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Clean</legend>
          <FilterChips
            filters={clean.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(clean.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Jerk</legend>
          <FilterChips
            filters={jerk.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(jerk.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Snatch</legend>
          <FilterChips
            filters={snatch.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(snatch.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Overhead Press</legend>
          <FilterChips
            filters={overheadPress.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(overheadPress.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>Other</legend>
          <FilterChips
            filters={other.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(other.find((ex) => ex._id === id))
            }
          />
        </fieldset>
      </div>
      {!isOnboarding && (
        <button
          data-button-type="primary"
          disabled={invalid ? true : undefined}
          onClick={handleSave}
        >
          Save
        </button>
      )}
    </section>
  );
};

export default memo(SelectedExercises);
